import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { http } from '@/shared/api/http';
import { invalidateTaskCaches } from '@/features/tasks/model/useTaskActions';

export function useRenewTask() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (taskId: string | number) => {
      const res = await http.post(`/tasks/${taskId}/renew`);
      return res.data;
    },
    onSuccess: () => {
      toast.success('Задача возобновлена');
      invalidateTaskCaches(queryClient);
    },
    onError: () => {
      toast.error('Не удалось возобновить задачу');
    },
  });

  return {
    renewTask: (id: string | number) => mutation.mutate(id),
    isLoading: mutation.isPending,
  };
}
